module.exports = __webpack_public_path__ + "img/borrower_signup_hero.667902bb.jpg";